<template>
  <el-table
    :data="statistik"
    border
    style="width: 80%"
    v-loading="isLoading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.9)"
  >
    <el-table-column prop="userDocName" label="Jenis Permohonan">
    </el-table-column>
    <el-table-column label="Jumlah" width="200px">
      <div slot-scope="props">
        <el-button
          @click.native="
            () => {
              $router.push(
                `/pasca-permohonan/list?userDocType=${props.row.userDocType}`
              );
            }
          "
          style="width: 100%"
        >
          {{ props.row.count }}
        </el-button>
      </div>
    </el-table-column>
  </el-table>
</template>

<script>
import api from "./api";
import { Table, TableColumn, Button, Message } from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Message.name]: Message,
  },
  data() {
    return {
      statistik: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.isLoading = true;
        const { resSelect } = await api.pascaPermohonanStatistik();
        this.statistik = resSelect.data;
      } catch (error) {
        Message.error(error.toString());
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
</style>